import { Link } from 'react-router-dom';
import WebsiteNavbar from './WebsiteNavbar';
import WebsiteFooter from './WebsiteFooter';
import './Website.css';

const WebsiteAbout = () => {
  return (
    <div className="website nx nx-refined">
      <WebsiteNavbar />

      <section className="nx-page-hero">
        <div className="nx-kicker">About the index</div>
        <h1>An independent record of service in Nigeria.</h1>
        <p>The Nigeria Customer Service Index (NCSI) is a national evaluation metric covering customer service across twelve sectors.</p>
      </section>

      <section className="nx-page-body">
        <div className="nx-mani-grid">
          <div className="nx-mani-copy">
            <div className="nx-kicker">What we do</div>
            <h2>Evidence, not anecdotes.</h2>
            <p>
              NCSI is an independent and objective compilation of customer
              satisfaction on quality of goods and service delivery across
              the nation. Responses are collated, probed and published as a
              holistic report that reveals trends, causes and effects shaping
              national life.
            </p>
            <ul className="nx-checks">
              <li>Receive, collate and analyse service experience data</li>
              <li>Publish periodic, comparable sector reports</li>
              <li>Give institutions a fair benchmark to improve on</li>
            </ul>
            <div className="nx-hero-btns" style={{ justifyContent: 'flex-start' }}>
              <Link to="/survey/" className="nx-btn nx-btn-primary">Take the survey</Link>
              <Link to="/sectors" className="nx-btn nx-btn-secondary">View sectors</Link>
            </div>
          </div>
          <div className="nx-mani-figure">
            <img src={process.env.PUBLIC_URL + '/images/about-visual.png'} alt="NCSI sector overview" />
            <div className="nx-mani-caption">
              <strong>Objective · National · Citizen-first</strong>
              <span>Compiled in association with research partners</span>
            </div>
          </div>
        </div>

        <div className="nx-values">
          <div className="nx-value">
            <span className="nx-param-n">01</span>
            <h3>Our Objectives</h3>
            <p>With our partners, receive, collate, analyse and present data on the state of customer service, delivery and experience in the country.</p>
          </div>
          <div className="nx-value">
            <span className="nx-param-n">02</span>
            <h3>Our Mission</h3>
            <p>Consistently aggregate all parameters and present a periodic report on the state of customer service in Nigeria.</p>
          </div>
          <div className="nx-value">
            <span className="nx-param-n">03</span>
            <h3>Our Vision</h3>
            <p>To be, without bias, the most reliable resource for service evaluation and the pacesetter for growth in customer service in Nigeria.</p>
          </div>
        </div>

        <div className="nx-page-cta">
          <div>
            <h2>Are you a service professional?</h2>
            <p>Join the growing ECOWAS customer service community through WAACSP.</p>
          </div>
          <a href="https://thewaacsp.com" target="_blank" rel="noopener noreferrer" className="nx-btn nx-btn-primary">Become a member</a>
        </div>
      </section>

      <WebsiteFooter />
    </div>
  );
};

export default WebsiteAbout;
